import { render } from "./LasVegas.vue?vue&type=template&id=6880f7ab&scoped=true"
import script from "./LasVegas.vue?vue&type=script&lang=js"
export * from "./LasVegas.vue?vue&type=script&lang=js"

import "./LasVegas.vue?vue&type=style&index=0&id=6880f7ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6880f7ab"]])

export default __exports__